import { render, staticRenderFns } from "./WaybillDetail.vue?vue&type=template&id=456f8eac&scoped=true&"
import script from "./WaybillDetail.vue?vue&type=script&lang=js&"
export * from "./WaybillDetail.vue?vue&type=script&lang=js&"
import style1 from "./WaybillDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f8eac",
  null
  
)

export default component.exports